import React, { forwardRef, memo } from 'react'
import styles from './DeadlinePanel.module.sass'
import { parseDate, toReadableDateString } from '../../../../utils/date-utils'
import {
    /*addDays,
    differenceInBusinessDays,
    differenceInHours,
    differenceInMilliseconds,*/
    endOfDay,
    /*endOfToday,
    formatDistanceStrict,
    subDays*/
} from 'date-fns'
import { pipe } from 'fp-ts/es6/function'
import { fromNullable, getOrElseW, map } from 'fp-ts/es6/Option'
//import { ru } from 'date-fns/locale'
import clsx from 'clsx'
import Tooltip from '../../../etc/Tooltip'
import { Classes } from '../../../../styles'

//const DEADLINE_THRESHOLD = 10 // hours

/*const isExpired = (deadline: Date): boolean => differenceInMilliseconds(deadline, new Date()) < 0
const isDeadline = (deadline: Date): boolean => differenceInHours(deadline, new Date()) < DEADLINE_THRESHOLD*/

interface Props {
    className?: string,
    value?: string,
    disabled?: boolean,
    onClick?: () => void,
    deadline_text?: string,
    deadline_type?: string
}

const DeadlinePanel = forwardRef<HTMLDivElement, Props>((props, ref) => {
    return pipe(
    parseDate(props.value),
    fromNullable,
    map(endOfDay),
    map(deadline => {
        /*const now = new Date()
        const difference = differenceInBusinessDays(deadline, now)
        const expired = isExpired(deadline)
        const correctedDeadline = (expired ? subDays : addDays)(endOfToday(), difference)*/
        return <div
            ref={ref}
            className={clsx(props.className, {[clsx(Classes.touchTarget, Classes.pointer)]: props.onClick})}
            onClick={props.onClick}
        >
            <Tooltip
                className={clsx(styles.panel, {
                    [styles.expired]: props.deadline_type === 'fail',
                    [styles.deadline]: props.deadline_type === 'close',
                    [styles.interactive]: props.onClick,
                })}
                title={`Срок ${toReadableDateString(deadline)} ${(props.onClick && !props.disabled) ? ' Изменить' : ''}`}
            >
                <div className={clsx(styles.date, Classes.f9)}>
                    {props.deadline_text}
                </div>
            </Tooltip>
        </div>
    }),
    getOrElseW(() => null)
)})


DeadlinePanel.displayName = 'DeadlinePanel'

export default memo(DeadlinePanel)
